<div class="flex flex-col gap-6">
  <span class="text-[18px] font-bold">Cumplimiento Reglamento de Inteligencia Artificial (RIA)</span>

  <div class="flex flex-col gap-6">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('usageInstructions')"
        (change)="reviewFields.toggleField('usageInstructions')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Instrucciones de uso</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('usageInstructions')"
            class="-mt-2"
            [description]="previousReviewText('usageInstructions')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.usageInstructions || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('humanSupervision')"
        (change)="reviewFields.toggleField('humanSupervision')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Supervision humana</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('humanSupervision')"
            class="-mt-2"
            [description]="previousReviewText('humanSupervision')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.humanSupervision || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('inputDataQuality')"
        (change)="reviewFields.toggleField('inputDataQuality')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Calidad de datos de entrada</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('inputDataQuality')"
            class="-mt-2"
            [description]="previousReviewText('inputDataQuality')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.inputDataQuality || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('qualityMonitoring')"
        (change)="reviewFields.toggleField('qualityMonitoring')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Monitorizacion continua de la calidad de los datos</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('qualityMonitoring')"
            class="-mt-2"
            [description]="previousReviewText('qualityMonitoring')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.qualityMonitoring || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('logRetention')"
        (change)="reviewFields.toggleField('logRetention')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Conservacion de registros (Logs)</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('logRetention')"
            class="-mt-2"
            [description]="previousReviewText('logRetention')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.logRetention || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('fria')"
        (change)="reviewFields.toggleField('fria')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Evaluacion de Impacto sobre Derechos Fundamentales (EIDF)</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('fria')"
            class="-mt-2"
            [description]="previousReviewText('fria')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.fria || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('dpia')"
        (change)="reviewFields.toggleField('dpia')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">DPIA</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('dpia')"
            class="-mt-2"
            [description]="previousReviewText('dpia')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.dpia || '-' }}</span>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-x-8 gap-y-6">
      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('naturalPersonInteractionCheck')"
          (change)="reviewFields.toggleField('naturalPersonInteractionCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Interaccion directa con personas fisicas</span>
            <app-tooltip
              *ngIf="
                reviewMode &&
                showPreviousReviewIndicators &&
                reviewFields.hasPreviousReview('naturalPersonInteractionCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('naturalPersonInteractionCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">{{ riaData?.naturalPersonInteractionCheck ? 'Si' : 'No' }}</span>
        </div>
      </div>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('contentGenerationCheck')"
          (change)="reviewFields.toggleField('contentGenerationCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Generacion de contenidos sinteticos</span>
            <app-tooltip
              *ngIf="
                reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('contentGenerationCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('contentGenerationCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">{{ riaData?.contentGenerationCheck ? 'Si' : 'No' }}</span>
        </div>
      </div>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('biometricsEmotionsCheck')"
          (change)="reviewFields.toggleField('biometricsEmotionsCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Reconocimiento de emociones o categorizacion biometrica</span>
            <app-tooltip
              *ngIf="
                reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('biometricsEmotionsCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('biometricsEmotionsCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">{{ riaData?.biometricsEmotionsCheck ? 'Si' : 'No' }}</span>
        </div>
      </div>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('publicInterestTextCheck')"
          (change)="reviewFields.toggleField('publicInterestTextCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Generacion o manipulacion de texto de interes publico</span>
            <app-tooltip
              *ngIf="
                reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('publicInterestTextCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('publicInterestTextCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">{{ riaData?.publicInterestTextCheck ? 'Si' : 'No' }}</span>
        </div>
      </div>

      <div class="flex gap-3 items-start col-span-2">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('userInformation')"
          (change)="reviewFields.toggleField('userInformation')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">
              Informacion sobre uso IA y medidas aplicadas para garantizar transparencia
            </span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('userInformation')"
              class="-mt-2"
              [description]="previousReviewText('userInformation')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">{{ riaData?.userInformation || '-' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
